import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CampaignModuleGate } from "@/features/admin/campaigns/campaign-module-gate";
import { CampaignsList } from "@/features/admin/campaigns/list";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  filters: z
    .object({
      // Boolean on/off. Accepts the empty-shell "" (chip added before a value is picked) plus
      // the canonical "true"/"false" the boolean widget writes.
      enabled: withOperators(
        z
          .union([z.literal("true"), z.literal("false"), z.literal("")])
          .optional(),
      ),
    })
    .optional(),
  ...filterSearchFragment,
  sort: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/campaigns/")({
  validateSearch: searchSchema,
  component: () => (
    <CampaignModuleGate>
      <CampaignsList />
    </CampaignModuleGate>
  ),
});
